import * as React from 'react'
import styles from './index.module.css'

type Props = {
  multiple?: boolean
  directory?: boolean
  onChange: (...args: Array<any>) => any
  className?: string
  children: React.ReactNode
  disabled?: boolean
}
/**
 * File selector component that opens native file/folder picker dialog
 * Supports both file and directory selection with multiple file selection
 * @param multiple - Whether to allow multiple file selection
 * @param directory - Whether to select directories instead of files
 * @param onChange - Callback function called when files are selected
 * @param className - Additional CSS class names to apply
 * @param children - Child elements to render as the clickable file selector trigger
 * @param disabled - Whether the file selector is disabled
 */
export default class FileSelect extends React.Component<Props> {
  _fileDrop: HTMLInputElement | null | undefined
  openFilesDialog: () => void = () => {
    if (this._fileDrop) this._fileDrop.click()
  }
  _onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { onChange, directory } = this.props
    const uploadType = {
      title: directory ? 'folder' : 'file',
    }
    if (!onChange) return
    onChange(Array.from(e.target.files!), uploadType)
    if (this._fileDrop) this._fileDrop.value = ''
  }

  render(): React.ReactNode {
    const { multiple, directory, className, disabled } = this.props
    return (
      <div
        onClick={disabled ? undefined : this.openFilesDialog}
        className={className}
      >
        <input
          className={styles.fileSelectInput}
          ref={r => {
            this._fileDrop = r
          }}
          type="file"
          multiple={multiple}
          // @ts-expect-error
          webkitdirectory={directory ? 'true' : undefined}
          onChange={disabled ? undefined : this._onChange}
          disabled={disabled}
        />
        {this.props.children}
      </div>
    )
  }
}
